import React from "react";
import "../../assets/css/site.css";
import { LuMail } from "react-icons/lu"
import { Link } from "react-router-dom"
import footer_bg from "../../assets/images/footer_bg.png"
import logo from "../../assets/images/weee-logo.png"
import '../home/Home2.css'

const Footer = () => {
    var logoHeight = 70
    var font1Size = 26
    var font2Size = 22
    var font3Size = 18

    if(window.innerWidth < 920 && window.innerWidth >= 576) {
        logoHeight = 50
        font1Size = 22
        font2Size = 18
        font3Size = 16
    } else if(window.innerWidth < 576) {
        logoHeight = 36
        font1Size = 20
        font2Size = 16
        font3Size = 14
    }
    
    return (
        <>
            <div className="container-fluid flex-container" style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 10, paddingBottom: 10, backgroundImage: `url(${footer_bg})`, backgroundSize: 'contain', backgroundRepeat:'repeat-x', backgroundPosition: 'bottom', flex: 1 }}>     
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                    <a className="navbar-brand" href="/"><img src={logo} className="" style={{ height: logoHeight }} alt="WEEE" /></a>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', flex: 1, marginLeft: 20 }}>
                    <div className="flex-container" style={{ flex: 1}}>
                        <p style={{marginRight: 40, marginBottom: 0}}><Link to={`/aboutus`} style={{ color: "#ffffff", fontSize: font1Size, fontWeight: "600"}}>เกี่ยวกับ WEEE</Link></p>
                        <p style={{ color: "#ffffff", fontSize: font1Size, fontWeight: "600", marginBottom: 0}}><LuMail /> ติดต่อเรา <font style={{ fontWeight: '400', fontSize: font2Size }}>app3r.info@gmail.com</font></p>
                    </div>
                    <div className="flex-container" style={{ flex: 1, backgroundColor: '#ffffff'}}>
                        <p style={{ color: "#000000", fontSize: font1Size, fontWeight: "600", marginBottom: 0 }}>ศูนย์ช่วยเหลือ</p>
                        <p style={{ marginLeft: 10, marginBottom: 0 }}><Link to={`/policy`} style={{ color: "#aaaaaa", fontSize: font3Size, fontWeight: "400"}}>ข้อกำหนดและเงื่อนไขการใช้งาน</Link></p>
                        <p style={{ marginLeft: 10, marginBottom: 0 }}><Link to={`/privacy`} style={{ color: "#aaaaaa", fontSize: font3Size, fontWeight: "400"}}>นโยบายความเป็นส่วนตัว</Link></p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;